import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { KuposImageSlider } from '.';

export class KuposServiceEmenities extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    console.log('+++state in amenities ', this.state);
    let images = [
      this.props.data.service_image_1,
      this.props.data.service_image_2,
      this.props.data.service_image_3,
    ];
    return (
      <div>
        <div
          className={
            'common-kupos-service-emenities' +
            (this.props.selectedLength - 1 == this.props.selectedKey ? ' border-raduis-bottom' : '')
          }
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {this.props.data && this.props.data.service_image_1 != '' ? (
              <KuposImageSlider
                autoPlay={true}
                onClick={val => this.props.onImageClick(val)}
                images={images}
              />
            ) : (
              <img
                style={{ height: 100, width: 100 }}
                src={'/static/images/icons/home/airport-transfer-circle.png'}
              />
            )}
          </div>
          <div>
            <div className="bold-text font9">Restricción de equipaje</div>
            <div className="description-text text-and-icons">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img
                  className="icon-size"
                  src={'/static/images/kupos-AirportTransfer-Results-IconBaggage.svg'}
                />
                <img
                  className="icon-size"
                  src={'/static/images/kupos-AirportTransfer-Results-IconHandLuggage.svg'}
                />
              </div>
              <span className="font9" style={{ lineHeight: 1.5 }}>
                {this.props.data && this.props.data.svc_restriction_info}
              </span>
            </div>
            <div className="bold-text font9">Políticas de cancelación</div>
            <div className="description-text">
              <span className="font9" style={{ lineHeight: 1.5 }}>
                {this.props.data && this.props.data.svc_cancellation_info}
              </span>
            </div>
            <div className="bold-text font9">Información adicional</div>
            <div className="description-text">
              <span className="font9" style={{ lineHeight: 1.5 }}>
                {this.props.data && this.props.data.svc_additional_info}
              </span>
            </div>
          </div>
          {this.props.selectedLength - 1 != this.props.selectedKey ? (
            <div className="at-hr-line"></div>
          ) : null}
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(KuposServiceEmenities);



// WEBPACK FOOTER //
// ./src/features/common/KuposServiceEmenities.js